import * as ActionTypes from '../ActionTypes'
import * as ReduxDataStatus from '../../utils/constants/ReduxDataStatus';

export const UsersReducer = (state = { 
                status: ReduxDataStatus.IDLE,
                loadTime: null,
                loadCriteria: {},
                errMess: null,
                users:[]
            }, action) => {
                
    switch (action.type) {
        case ActionTypes.USERS_LOADING:
            return {...state, status: ReduxDataStatus.LOADING, errMess: null, users: [], loadTime: Date.now(), loadCriteria: action.payload}

        case ActionTypes.ADD_USERS:
            return {...state,  status: ReduxDataStatus.SUCCEEDED, errMess: null, users: action.payload};

        case ActionTypes.USERS_FAILED:
            return {...state, status: ReduxDataStatus.FAILED, errMess: action.payload, loadTime: null, loadCriteria: {}};

        case ActionTypes.ADD_USER:
            const nUser = action.payload;
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, users: state.users.concat(nUser)};
    
        case ActionTypes.UPDATE_USER:
            const uUser = action.payload;
            const updatedUsers = state.users.map(e => (e.id === uUser.id && e.type === uUser.type) ? uUser : e );
            return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, users: updatedUsers};

        // case ActionTypes.DELETE_USER:
        //     const duId = action.payload;
        //     const filteredUsers = state.users.filter(e => e.id !== duId);
        //     return {...state, status: ReduxDataStatus.SUCCEEDED, errMess: null, users: filteredUsers};

        default:
            return state;
    }
};